import { ArrowDownTrayIcon, CalculatorIcon, ClipboardIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import { useState } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/payslipActions";
import { Row } from "@/common/custom-lists/ListView";
import Tooltip from "@/tooltip";
import { roundTo2 } from "../../common/validation/Validators";
import "./PayslipRowStyles.css";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const PayslipRow = ({
	payslip,
	disabled,
	downloadPayslip,
	showInPortal,
	currency,
	taxList,
	isAdmin,
	openModal,
	location,
}) => {
	const [view, setView] = useState(payslip.employeeCanView);

	const taxes = payslip?.taxes;

	return (
		<Row
			actionColumns={[0]}
			columns={[
				isAdmin ? (
					<div className="btn-group">
						<Tooltip
							content={`Copy Id`}
							arrowSize={4}
						>
							<div
								className="btn btn-xs btn-default mr-3"
								type="button"
								onClick={() => copyToClipboard(payslip.id)}
							>
								<ClipboardIcon className="w-5 h-5 mb-1 media-middle" />
							</div>
						</Tooltip>
					</div>
				) : (
					<div />
				),
				location == "payrollHistory" && (
					<a
						onClick={() => downloadPayslip(payslip.id)}
						style={{ cursor: "pointer", color: "#ea611c" }}
					>
						{payslip.employee}
					</a>
				),
				location != "payrollHistory" && payslip?.periodDescription,
				`${currency}${roundTo2(parseFloat(payslip?.gross))}`,
				...Object.values(taxList).map((taxName, index) => {
					const tax = taxes?.filter((t) => t.taxVariable.taxName == taxName);
					const totalAmount = tax?.reduce((acc, t) => acc + t.amount, 0);

					return (
						<div
							onClick={() => {
								if (
									tax?.length == 0 ||
									totalAmount === 0
								)
									return;
								openModal(tax);
							}}
							style={{ cursor: tax?.length > 0 && totalAmount > 0 ? "pointer" : "default" }}
							className={`${tax?.length > 0 && totalAmount > 0 && "taxHover"}`}
						>
							{currency}
							{roundTo2(
								_.sumBy(
									taxes?.filter?.(
										(t) =>
											t.taxVariable.taxName == taxName &&
											["Both", "Employee"].includes(t.taxVariable.payer),
									),
									"amount",
								),
							)}
						</div>
					);
				}),
				`${currency}${roundTo2(parseFloat(payslip?.net))}`,

				<div
					title="Show in Portal"
					className="form-material"
					style={{ minWidth: 43, display: "inline-block", flexShrink: 0 }}
				>
					<label
						style={{ padding: 0 }}
						className="css-input switch switch-sm switch-primary"
					>
						<input
							type="checkbox"
							checked={view}
							disabled={disabled}
							style={{ width: "30px" }}
							onClick={(e) => {
								if (!disabled) {
									setView(!view);
									showInPortal({ id: payslip.id, checked: e.target.checked });
									// e.preventDefault()
									// e.stopPropagation()
								}
							}}
						/>
						<span />
					</label>
					<div className="clearfix" />
				</div>,
				<a
					className="btn btn-xs btn-default"
					onClick={() => downloadPayslip(payslip.id)}
				>
					<Tooltip content="Download Payslip">
						<ArrowDownTrayIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</Tooltip>
				</a>,
			]}
		/>
	);
};

const mapStateToProps = (state) => {
	// console.log('state',state && state.timesheets)
	const jurisdiction = state.company?.settings?.jurisdiction;
	const taxList = {
		UK: { PAYE: "PAYE", NIC: "NIC", StudentLoan: "Student Loan", Pension: "Pension" },
		MT: { FSS: "FSS", SSC: "SSC" },
	};

	return {
		currency: state?.company?.settings?.currency,
		disabled: state?.permissions?.my?.permissions?.payroll == "Read",
		taxList: taxList[jurisdiction],
		isAdmin: state.my?.profile?.isAdmin || false,
		jurisdiction,
	};
};

const mapDispatchToProps = (dispatch) => ({
	downloadPayslip: (id) => dispatch(ACTIONS.downloadPayslip(id)),
	showInPortal: (input) => dispatch(ACTIONS.showInPortal(input)),
	openModal: (tax) => dispatch(ACTIONS.setTaxModal({ show: true, tax })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipRow);
